<template>
  <View gap="sm" direction="column">
    <View gap="md" direction="row" justify="space-between" padding-block="sm">
      <Text variant="h3">
        <span>Actions needed</span>
        <Text variant="h3" as="span" color="tertiary">&nbsp;({{ data.length }})</Text>
      </Text>

      <ShowMoreButton v-if="hasMoreDataThanLimit" @click="openModal" />
    </View>

    <PlaceholderSection
      v-if="isPending || data.length === 0"
      :is-loading="isPending"
      :icon="'check-done-01'"
      title="No actions needed right now"
      description="New items requiring your attention will appear here"
    />

    <ActionsNeededList v-else :items="items" @open-wants-to-apply="openWantsToApply" />

    <ActionsNeededModal ref="actionsNeededModalRef" @open-wants-to-apply="openWantsToApply" />

    <WantsToApplyPanel
      v-if="selectedInquiry"
      ref="wantsToApplyPanelRef"
      :inquiry="selectedInquiry"
      @closed="selectedInquiry = undefined"
    />
  </View>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue';

import { Text, View } from '@tallo/design-system';
import { ActionsNeededList, ActionsNeededModal, useActionsNeeded } from '@tallo/investor/actions-needed';
import { PropertyInquiryDto } from '@tallo/investor/property';

import WantsToApplyPanel from '../wants-to-apply/wants-to-apply-panel.vue';
import PlaceholderSection from './placeholder-section.vue';
import ShowMoreButton from './show-more-button.vue';

const { data, isPending } = useActionsNeeded();
const limit = 2;
const items = computed(() => data.value.slice(0, limit));
const hasMoreDataThanLimit = computed(() => data.value.length > limit);
const actionsNeededModalRef = ref<InstanceType<typeof ActionsNeededModal>>();

const selectedInquiry = ref<PropertyInquiryDto>();
const wantsToApplyPanelRef = ref<InstanceType<typeof WantsToApplyPanel>>();

function openModal() {
  actionsNeededModalRef.value?.open();
}

// From the two cards shown here or the full list's panel, which it then opens over
async function openWantsToApply(inquiry: PropertyInquiryDto) {
  selectedInquiry.value = inquiry;
  await nextTick();
  wantsToApplyPanelRef.value?.open();
}
</script>

<style scoped lang="scss"></style>
